import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { H4 } from '../../base';
import { colors, fonts, leading } from '../../styles/theme';
import NotificationCTA from './NotificationCTA';

export const NotificationWrapper = styled('div')`
  background: ${colors.grey.secondaryLight};
  border: 1px solid ${colors.grey.secondaryDark};
  font-size: ${fonts.sans.size.normal};
  line-height: ${leading.full};
  padding: 20px;
  position: relative;
  border-radius: 3px;
`;

const NotificationHeadline = styled(H4)`
  color: ${colors.black};
  margin: 0;
`;

NotificationHeadline.propTypes = {
  children: PropTypes.string.isRequired,
};

const NotificationBodyWrapper = styled('div')`
  margin: 15px 0;
  color: ${colors.grey.primary};
`;

const NotificationSubtext = styled('div')`
  margin: 12px 0;
  line-height: 18px;
  color: ${colors.grey.primary};
  font-size: ${fonts.sans.size.small};
  font-style: italic;
`;

NotificationSubtext.propTypes = {
  children: PropTypes.string.isRequired,
};

const Notification = (props) => {
  const {
    headline,
    message,
    children,
    onDecline,
    onAccept,
    showDeclineMsg,
    declineComponent,
    declineButtonMsg,
    acceptButtonMsg,
    subtext,
  } = props;

  const CTASection =
    showDeclineMsg && declineComponent ? (
      declineComponent
    ) : (
      <NotificationCTA
        handleDecline={onDecline}
        handleAccept={onAccept}
        declineButtonMsg={declineButtonMsg}
        acceptButtonMsg={acceptButtonMsg}
      />
    );

  const body = message || children;

  const subtextSection = subtext ? <NotificationSubtext>{subtext}</NotificationSubtext> : null;

  return (
    <NotificationWrapper>
      <NotificationHeadline>{headline}</NotificationHeadline>
      <NotificationBodyWrapper>{body}</NotificationBodyWrapper>
      {subtextSection}
      {CTASection}
    </NotificationWrapper>
  );
};

Notification.propTypes = {
  headline: PropTypes.string.isRequired,
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onDecline: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  declineButtonMsg: PropTypes.string.isRequired,
  acceptButtonMsg: PropTypes.string.isRequired,
  showDeclineMsg: PropTypes.bool,
  declineComponent: PropTypes.element,
  subtext: PropTypes.string,
};

Notification.defaultProps = {
  showDeclineMsg: false,
  declineComponent: null,
  subtext: null,
  message: null,
  children: null,
};

export { Notification };
